export default {"src":"/_next/static/media/carousel-left.1baccef8.svg","height":42,"width":60,"blurWidth":0,"blurHeight":0};